import React from 'react';
import { Pagination } from 'react-bootstrap';

const PaginationComponent  = ({ currentPage, lastPage, onPageChange }) => {
    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < lastPage) {
            onPageChange(currentPage + 1);
        }
    };

    // Gerar itens de paginação dinamicamente para exibição
    const paginationItems = [];
    for (let number = 1; number <= lastPage; number++) {
        paginationItems.push(
            <Pagination.Item
                key={number}
                active={number === currentPage}
                onClick={() => onPageChange(number)}
            >
                {number}
            </Pagination.Item>
        );
    }

    return (
        <Pagination>
            <Pagination.Prev onClick={handlePrevious} disabled={currentPage === 1} />
            {paginationItems}
            <Pagination.Next onClick={handleNext} disabled={currentPage === lastPage} />
        </Pagination>
    );
};

export default PaginationComponent;
